import maintainerApi from 'api/maintainerApi';
import MaintainerHelper from 'features/Maintainer/maintainerHelper';
import SystemHelper from 'features/System/systemHelper';
import KTFormInput, {
    KTFormInputType,
} from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import CustomDropdown2 from 'general/components/Others/CustomDropdown2';
import AppColors from 'general/constants/AppColors';
import ToastHelper from 'general/helpers/ToastHelper';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import { useEffect, useMemo, useState } from 'react';

DialogAdminAssignTicketView.propTypes = {
    item: PropTypes.object,
    onCancel: PropTypes.func,
    onDone: PropTypes.func,
};

function DialogAdminAssignTicketView({ item, onCancel, onDone }) {
    // MARK: ---- PROPERTIES ----
    const [loading, setLoading] = useState(false);
    const [readyToValidate, setReadyToValidate] = useState(false);
    const [priority, setPriority] = useState('');
    const [deadline, setDeadline] = useState('');
    const [assignmentMode, setAssignmentMode] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);

    useEffect(() => {
        if (item) {
            setPriority(item?.priority);
            setDeadline(item?.deadline);
            setAssignmentMode(item?.assignmentMode);
        }
    }, [item]);

    // MARK: ---- FUNCTIONS ----
    const handleSubmit = async () => {
        setReadyToValidate(true);
        if (
            !Utils.isValid(priority) ||
            !Utils.isValid(deadline) ||
            !Utils.isValid(assignmentMode)
        ) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }
        if (Utils.isValid(assignmentMode) && assignmentMode === 'ASSIGNED' && !Utils.isValid(selectedUser)) {
            ToastHelper.showError('Vui lòng nhập đầy đủ thông tin');
            return;
        }

        setLoading(true);

        let params = {
            ticketId: item.ticketId,
            priority,
            deadline,
            assignmentMode,
            userId: selectedUser?.id,
        };
        params = _.pickBy(params, (value) => value !== null && value !== undefined && value !== '');
        const res = await MaintainerHelper.API.requestAssignTicket(params);
        if (_.isBoolean(res) && res) {
            ToastHelper.showSuccess('Phân phối công việc thành công');
            onDone && onDone();
        } else if (_.isString(res)) {
            ToastHelper.showError(res);
        }
        setLoading(false);
    };

    const userOptions = [
        { name: 'Kỹ thuật viên', role: 'MAINTAINER' },
        { name: 'Nhân viên NĐH', role: 'ADMIN_STAFF' },
        { name: 'Người quản lý trạm', role: 'STATION_MANAGER' },
    ]
    const dropdownUserEl = useMemo(() => {
        return (
            <CustomDropdown2
                id="stationId_dialog"
                name="stationId_dialog"
                ignoreConfirmClick={true}
                toggleElement={
                    <button
                        className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between
                           ${readyToValidate && !Utils.isValid(selectedUser) ? 'button-invalid' : ''} `}
                        type="button"
                    >
                        {selectedUser?.name ?? 'Chọn người thực hiện'}
                    </button>
                }
                selectedValue={selectedUser}
                dropdownMenuItems={userOptions}
                getSubItems={async (it) => {
                    try {
                        if (it?.role === 'MAINTAINER') {
                            return await maintainerApi.getMaintainerList(
                                Utils.filterParams({
                                    page: it?.page || 0,
                                    limit: 10,
                                    q: it?.q || '',
                                })
                            ).then((data) => {
                                return {
                                    values: data.maintainers?.map((maintainer) => ({
                                        id: maintainer?.users?.[0]?.userId,
                                        name: maintainer?.name,
                                        email: maintainer?.email,
                                        item: maintainer,
                                    })),
                                    total: data.total,
                                };
                            });
                        }
                        if (it?.role === 'ADMIN_STAFF') {
                            return SystemHelper.API.User.requestGetUserList({
                                page: it?.page || 0,
                                limit: 10,
                                role: 'ADMIN',
                                position: "INFRA_ENGINEERING_MANAGER, INFRA_ENGINEER",
                                q: it?.q || '',
                            }).then((data) => {
                                return {
                                    values: data?.users?.map((user) => ({
                                        id: user?.userId,
                                        name: user?.fullname,
                                        email: user?.email,
                                        item: user,
                                    })),
                                    total: data.total,
                                };
                            });
                        }
                        if (it?.role === 'STATION_MANAGER') {
                            return await MaintainerHelper.API.getChargeStationDetail(item?.stationId).then((chargeStation) => {
                                if (chargeStation?.landlordId) {
                                    return {
                                        values: chargeStation?.landlord?.users?.map((user) => ({
                                            id: user?.userId,
                                            name: user?.fullname,
                                            item: user,
                                        })),
                                        total: chargeStation?.landlord?.users?.length,
                                    };
                                } else if (chargeStation?.agencyId) {
                                    return {
                                        values: chargeStation?.investor?.users?.map((user) => ({
                                            id: user?.userId,
                                            name: user?.fullname,
                                            item: user,
                                        })),
                                        total: chargeStation?.investor?.users?.length,
                                    };
                                }
                            });
                        }
                    } catch (error) {
                        console.error('Error fetching station list:', error);
                        return { values: [], total: 0 };
                    }
                }}
                dropdownMenuStyle={{ maxHeight: '30vh' }}
                dropdownMenuClassName="overflow-auto w-100"
                onChange={(value) => {
                    setSelectedUser(value);
                }}
                isDropdownForm={true}
                titleSearchable={true}
                searchable={true}
                searchFormClassName="mx-3 my-1 search-form-border"
                idCheckType='id'
                subTitleType='email'
            />
        )
    }, [selectedUser, readyToValidate, item])

    console.log('item: ', item?.stationId);

    return (
        <div>
            <div className="row m-0 p-0 px-2 mt-4">
                {/* deadline */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Thời gian cần xử lý', true)}
                    <KTFormInput
                        name="contractValidFrom"
                        placeholder="Chọn thời gian cần xử lý"
                        type={KTFormInputType.date}
                        value={deadline}
                        onChange={(value) => setDeadline(value)}
                        minTime={moment()}
                        enableCheckValid={readyToValidate}
                        isValid={Utils.isValid(deadline)}
                        isTouched={readyToValidate}
                    />
                </div>
                {/* assignmentMode */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Kiểu phân phối công việc', true)}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'button-invalid' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    MaintainerHelper.Data.assignmentModeOptions,
                                    (item) => item.value === assignmentMode
                                )?.name ?? 'Chọn kiểu phân phối'}
                            </button>
                        )}
                        selectedValue={assignmentMode}
                        dropdownMenuItems={MaintainerHelper.Data.assignmentModeOptions}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => setAssignmentMode(value)}
                        enableCheckValid
                        isDropdownForm={true}
                        isValid={Utils.isValid(assignmentMode)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(assignmentMode) ? "Vui lòng chọn kiểu phân phối" : ''}
                    />
                </div>
                {/* userId */}
                {assignmentMode === 'ASSIGNED' && (
                    <div className="col-md-12 mb-4 px-2">
                        {UIHelper.buildFormLabel('Người thực hiện', true)}
                        {dropdownUserEl}
                    </div>
                )}
                {/* priority */}
                <div className="col-md-12 mb-4 px-2">
                    {UIHelper.buildFormLabel('Độ ưu tiên', true)}
                    <KTBSDropdown
                        toggleElement={({ showError }) => (
                            <button
                                className={`btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between ${showError ? 'button-invalid' : ''}`}
                                type="button"
                            >
                                {_.find(
                                    MaintainerHelper.Data.ticketPriorityOptions,
                                    (item) => item.value === priority
                                )?.name ?? 'Chọn độ ưu tiên'}
                            </button>
                        )}
                        selectedValue={priority}
                        dropdownMenuItems={MaintainerHelper.Data.ticketPriorityOptions}
                        dropdownMenuStyle={{ maxHeight: '30vh' }}
                        dropdownMenuClassName="overflow-auto w-100"
                        onChange={(value) => setPriority(value)}
                        enableCheckValid
                        isDropdownForm={true}
                        isValid={Utils.isValid(priority)}
                        isTouched={readyToValidate}
                        feedbackText={readyToValidate && !Utils.isValid(priority) ? "Vui lòng chọn độ ưu tiên" : ''}
                    />
                </div>
            </div>
            {/* actions */}
            <div
                className="d-flex align-items-center justify-content-end gap-3 px-4 py-3"
                style={{
                    borderTop: `1px solid ${AppColors.gray[200]}`,
                }}
            >
                {UIHelper.buildNegativeButton('Hủy bỏ', onCancel, null)}
                {UIHelper.buildGreenButton(
                    'Cập nhật',
                    handleSubmit,
                    null,
                    false,
                    loading
                )}
            </div>
        </div>
    );
}

export default DialogAdminAssignTicketView;
